var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5L9.91 6.59L12 8.68M4.27 3.5L3 4.77L7.73 9.5H3V15.5H7L12 20.5V13.77L16.25 18.03C15.58 18.54 14.83 18.96 14 19.2V21.27C15.38 20.95 16.63 20.32 17.68 19.46L19.73 21.5L21 20.23L12 11.23M19 12.5C19 13.44 18.8 14.32 18.46 15.14L19.97 16.65C20.6455 15.3709 20.999 13.9465 21 12.5C21 8.22 18 4.64 14 3.73V5.79C16.89 6.65 19 9.33 19 12.5ZM16.5 12.5C16.5 10.73 15.5 9.21 14 8.47V10.68L16.45 13.13C16.5 12.93 16.5 12.71 16.5 12.5Z",
    fill: "#959BA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/volume_off.85ddf1a5338d31bb1b40c171d2fd2222.svg";
export { ForwardRef as ReactComponent };